export default "__VITE_ASSET__Dt7dtDNM__"